import "../../assets/css/SalesBill.css";
import ApiUrl from "./../Environment/ApiUrl";
import axios from "axios";
import { useParams } from "react-router-dom";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

const Loanbill = () => {
  const { loan_id } = useParams();
  const [loanData, setLoanData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    if (loan_id) {
      fetchLoanData();
    }
  }, [loan_id]);

  const fetchLoanData = async () => {
    try {
      setLoading(true);
      console.log("Fetching for loan_id:", loan_id);

      const response = await axios.get(
        `${ApiUrl}/Api/loan.php?loan_id=${loan_id}`
      );

      console.log("API response:", response.data);

      const allData = response.data.data || [];
      const filteredData = allData.find(
        // eslint-disable-next-line eqeqeq
        (item) => item.loan_id == loan_id
      ) || allData[0]; // fallback to first record if API already filtered by loan_id
      console.log("Filtered data:", filteredData);

      if (filteredData) {
        setLoanData(filteredData);
      } else {
        setError(`No loan data found for loan ID: ${loan_id}`);
      }
    } catch (error) {
      console.error("API error:", error);
      setError("Failed to fetch loan data");
    } finally {
      setLoading(false);
    }
  };

  // Format date from YYYY-MM-DD to DD-MMM-YYYY
  const formatDate = (dateString) => {
    if (!dateString) return "";

    const date = new Date(dateString);
    const options = { year: "numeric", month: "short", day: "2-digit" };
    return date.toLocaleDateString("en-US", options);
  };

  // Function to convert number to words for amount display
  const numberToWords = (num) => {
    const ones = [
      "",
      "One",
      "Two",
      "Three",
      "Four",
      "Five",
      "Six",
      "Seven",
      "Eight",
      "Nine",
      "Ten",
      "Eleven",
      "Twelve",
      "Thirteen",
      "Fourteen",
      "Fifteen",
      "Sixteen",
      "Seventeen",
      "Eighteen",
      "Nineteen",
    ];
    const tens = [
      "",
      "",
      "Twenty",
      "Thirty",
      "Forty",
      "Fifty",
      "Sixty",
      "Seventy",
      "Eighty",
      "Ninety",
    ];

    if (num === 0) return "Zero";

    const convertLessThanThousand = (num) => {
      if (num === 0) return "";
      if (num < 20) return ones[num];
      const ten = Math.floor(num / 10);
      const unit = num % 10;
      return tens[ten] + (unit ? " " + ones[unit] : "");
    };

    const numStr = num.toString();
    const numFloat = parseFloat(numStr);
    const intPart = Math.floor(numFloat);

    let result = "";
    let remaining = intPart;

    if (remaining >= 100000) {
      result +=
        convertLessThanThousand(Math.floor(remaining / 100000)) + " Lakh ";
      remaining = remaining % 100000;
    }

    if (remaining >= 1000) {
      result +=
        convertLessThanThousand(Math.floor(remaining / 1000)) + " Thousand ";
      remaining = remaining % 1000;
    }

    if (remaining >= 100) {
      result +=
        convertLessThanThousand(Math.floor(remaining / 100)) + " Hundred ";
      remaining = remaining % 100;
    }

    if (remaining > 0) {
      result += convertLessThanThousand(remaining);
    }

    return result.trim() + " Only";
  };

  // Calculate totals from loan items
  const calculateTotals = () => {
    if (!loanData?.loan_list)
      return {
        totalQty: 0,
        totalWeight: 0,
        totalAmount: 0,
      };

    return loanData.loan_list.reduce(
      (acc, item) => {
        acc.totalQty += parseInt(item.quantity) || 0;
        acc.totalWeight += parseFloat(item.weight) || 0;
        acc.totalAmount += parseFloat(item.amount) || 0;
        return acc;
      },
      { totalQty: 0, totalWeight: 0, totalAmount: 0 }
    );
  };

  // Calculate payment totals
  const calculatePaymentTotals = () => {
    if (!loanData?.loan_payment_history)
      return {
        totalPaid: 0,
        balance: 0,
      };

    const totalPaid = loanData.loan_payment_history.reduce(
      (sum, payment) => sum + parseFloat(payment.amount || 0),
      0
    );

    const balance = parseFloat(loanData.loan_amount || 0) - totalPaid;

    return {
      totalPaid,
      balance,
    };
  };

  if (loading) return <div>Loading loan data...</div>;
  if (error) return <div>{error}</div>;
  if (!loanData) return <div>No loan data available</div>;

  const { totalQty, totalWeight, totalAmount } = calculateTotals();
  const { totalPaid, balance } = calculatePaymentTotals();
  const formattedLoanDate = formatDate(loanData.loan_date);
  const formattedReturnDate = formatDate(loanData.return_date);
  const formattedCloseDate = formatDate(loanData.loan_close_date);
  const currentTime = new Date().toLocaleTimeString("en-US", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });

  return (
    <div className="bill-container">
      {/* Print Button (visible only on screen) */}
      <button className="print-btn no-print" onClick={() => window.print()}>
        Print Bill
      </button>
      <button className="cancel-btn no-print" onClick={() => navigate("/loan")}>
        Cancel
      </button>

      {/* Header Section */}
      <div className="header-section row align-items-center">
        {/* Left: Logo */}
        <div className="col-3 text-start">
          <img
            src={require("../../assets/images/Final logo c .png")}
            alt="TIRUPUR Logo"
            className="img-fluid"
            style={{ maxHeight: "50px" }}
          />
        </div>

        {/* Center: Company Info */}
        <div className="col-6 company-info text-center">
          <h4 className="mb-1">TIRUPUR JEWELLERY</h4>
          <p className="mb-0">
            3/1, Thandan St, Shevapet, Salem, Tamil Nadu 636002
          </p>
          <p className="mb-0">Ph: 04272233807</p>
        </div>

        {/* Right: Empty (to balance layout) */}
        <div className="col-3 company-info">
          <h4 className="text-dark">LOAN RECEIPT</h4>
        </div>
      </div>

      <hr className="divider" />

      {/* Loan Details Section */}
      <div className="details-section">
        <div className="customer-info">
          <div className="customer-details">
            <p>{loanData.customer?.name}</p>
            <p>{loanData.customer?.address}</p>
            <p>Cell: {loanData.customer?.mobile}</p>
            <p>Customer ID: {loanData.customer_id}</p>
          </div>
        </div>
        <div className="invoice-info">
          <div className="info-row">
            <span>Loan Date</span>
            <span>: {formattedLoanDate}</span>
          </div>
          <div className="info-row">
            <span>Loan ID</span>
            <span>: {loanData.loan_id}</span>
          </div>
          <div className="info-row">
            <span>Return Date</span>
            <span>: {formattedReturnDate || "Not returned"}</span>
          </div>
          <div className="info-row">
            <span>Status</span>
            <span>: {loanData.loan_status}</span>
          </div>
          {loanData.loan_status === "Close" && (
            <div className="info-row">
              <span>Closed Date</span>
              <span>: {formattedCloseDate}</span>
            </div>
          )}
        </div>
      </div>

      {/* Table Section */}
      <div className="table-section">
        <table className="bill-table">
          <thead>
            <tr>
              <th>S.No</th>
              <th>Description</th>
              <th>Category</th>
              <th>Qty</th>
              <th>Weight (g)</th>
              <th>Amount (₹)</th>
            </tr>
          </thead>
          <tbody>
            {loanData.loan_list &&
              loanData.loan_list.map((item, index) => (
                <tr key={index}>
                  <td>{index + 1}</td>
                  <td>{item.product_name}</td>
                  <td>{item.category}</td>
                  <td>{item.quantity}</td>
                  <td>{parseFloat(item.weight).toFixed(3)}</td>
                  <td>{parseFloat(item.amount).toFixed(2)}</td>
                </tr>
              ))}
          </tbody>
          <tfoot>
            <tr className="table-footer">
              <th colSpan="3">Total</th>
              <th>{totalQty}</th>
              <th>{totalWeight.toFixed(3)}</th>
              <th>{totalAmount.toFixed(2)}</th>
            </tr>
          </tfoot>
        </table>
      </div>

      <div className="details-section">
        <div className="customer-info">
          <div className="amount-in-words">
            <p>Rupees: {numberToWords(parseFloat(totalPaid))}</p>
          </div>
          <p>*Terms & Conditions</p>
          <p className="paragraph-cont">
            Loan must be repaid within {loanData.no_of_month} months
            <br />
            All pledged items will be returned upon full repayment
            <br />
            Late payments may incur additional charges
          </p>
        </div>
        <div className="invoice-info">
          <div className="totals-section">
            <div className="totals-grid">
              <div className="total-row">
                <span>Loan Amount</span>
                <span>{parseFloat(loanData.loan_amount).toFixed(2)}</span>
              </div>
              <div className="total-row">
                <span>Total Paid</span>
                <span>{totalPaid.toFixed(2)}</span>
              </div>
              <div className="total-row highlight">
                <span>Balance</span>
                <span>{balance.toFixed(2)}</span>
              </div>
              <div className="total-row">
                <span>Loan Status</span>
                <span>{loanData.loan_status}</span>
              </div>
              {loanData.notes && (
                <div className="total-row">
                  <span>Notes</span>
                  <span>{loanData.notes}</span>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      <hr className="divider" />

      {/* Footer Section */}
      <div className="footer-section">
        <div className="signatures">
          <div className="customer-sign">
            <p>Signature of the Borrower</p>
          </div>

          <div className="">
            <p className="footer-notes">--- Thank You ---</p>
            <div className="alaan">
              <p>Developed by Aalan Tech Soft - Salem</p>
            </div>
          </div>

          <div className="company-sign">
            <p>FOR TIRUPUR JEWELLERY </p>
            <p>Authorized Signature</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Loanbill;